import { ReactNode } from "react";

interface ProgressContainerProps {
  children: ReactNode;
  className?: string;
  progressValue?: number;
}

export const ProgressContainer = ({
  children,
  className = "",
  progressValue = 50,
}: ProgressContainerProps) => {
  return (
    <div className={`flex flex-col h-screen w-full md:w-[calc(100vw-2.5rem)] md:h-[calc(100vh-2.5rem)] bg-structural-white md:m-[1.3125rem] rounded-2xl border border-structural-white shadow-[3px_4px_16px_4px_rgba(0,0,0,0.08)] overflow-hidden ${className}`}>
      {/* Progress bar at the top */}
      <div className="w-full h-2 relative">
        <div className="absolute inset-0 bg-[var(--dash-accent,#20B486)] h-2" style={{ width: `${progressValue}%` }} />
      </div>
      
      {/* Main content container */}
      <div className="flex-1 flex items-center justify-center p-4 shadow-xs h-full">
        <div className="flex flex-col items-center text-center h-full justify-center">
          {/* Container Content */}
          {children}
        </div>
      </div>
    </div>
  );
};
 